"use strict";

exports.__esModule = true;
exports.getRandomOwner = getRandomOwner;
exports.default = void 0;

var _owner = _interopRequireDefault(require("../data/owner"));

var _ = require("./");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const owners = [{
  name: "val",
  title: "Valdresmusea"
}, {
  name: "byg",
  title: "Bygdøy Kongsgård"
}, {
  name: "nmm",
  title: "Norsk Maritimt Museum"
}, {
  name: "kyst",
  title: "Kystmyseet"
}, {
  name: "nkim",
  title: "Nordenfjeldske Kunstindustrimuseum"
}, {
  name: "kvi",
  title: "Kvinnemuseet"
}, {
  name: "fet",
  title: "Fetsund Lenser"
}];
const ownerImages = ["https://dms-cf-09.dimu.org/image/032yiVGVkzHu", "https://dms-cf-09.dimu.org/image/032yiziWuETr"];

function getRandomOwner() {
  const _getRandomArrayItem = (0, _.getRandomArrayItem)(owners),
        name = _getRandomArrayItem.name,
        title = _getRandomArrayItem.title;

  const imageUrl = (0, _.getRandomArrayItem)(ownerImages);
  return _extends({}, _owner.default, {
    name: name,
    title: title,
    imageUrl: imageUrl,
    theme: (0, _.getRandomTheme)()
  });
}

var _default = getRandomOwner;
exports.default = _default;